import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class DocumentInfoApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'documentInfo'
  }

  public getDocumentInfoList(CurrentPageIndex,PageSize,documentInfo){
    return this.send(documentInfo,"getDocumentInfoList?CurrentPageIndex="+CurrentPageIndex+"&PageSize="+PageSize,this.Methods.GET)
  }

  public getDocumentTypeList(projectIds,userId,userIds){
    return this.send({projectIds:projectIds,userId:userId,userIds:userIds},"getDocumentTypeList",this.Methods.GET)
  }


  /**
   * 获取附件信息
   */
  public getFileListByDocumentId(params){
    return this.send(params,"getFileListByDocumentId",Methods.GET)
  }

  public getFileListByIsPublic(params){
    return this.send(params,"getFileListByIsPublic",Methods.GET)
  }

  public getDocumentIsPublicList(CurrentPageIndex,PageSize,documentInfo){
    return this.send(documentInfo,"getDocumentIsPublicList?CurrentPageIndex="+CurrentPageIndex+"&PageSize="+PageSize,this.Methods.GET)
  }



  

}